(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dba-booking"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.dba-booking__play');
    if (!button) return;
    const holder = document.createElement('div');
    holder.className = 'dba-booking__frame';
    const frame = document.createElement('iframe');
    const id = encodeURIComponent(button.dataset.videoId);
    frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1`;
    frame.title = button.dataset.title || 'YouTube video';
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    holder.appendChild(frame);
    button.replaceWith(holder);
    frame.focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dba-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const embed = (id, params) =>
      `https://www.youtube-nocookie.com/embed/${id}?${new URLSearchParams(params).toString()}`;
    const tell = (frame, func, args = []) => {
      if (frame && frame.contentWindow) {
        frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func, args, id: 1, channel: 'widget' }), '*');
      }
    };

    // Shopify's Customer Privacy API: where the banner asks for consent, wait for it.
    const consentGiven = () => {
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.shouldShowBanner !== 'function' || !cp.shouldShowBanner()) return true;
      return typeof cp.marketingAllowed === 'function' && cp.marketingAllowed();
    };

    const startBackground = (root) => {
      const bg = root.querySelector('[data-bg-id]');
      if (!bg || bg.dataset.started) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (navigator.connection && navigator.connection.saveData) return;
      if (!consentGiven()) {
        document.addEventListener('visitorConsentCollected', () => startBackground(root), { once: true });
        return;
      }
      bg.dataset.started = '1';
      const id = bg.dataset.bgId;
      const start = parseInt(bg.dataset.bgStart, 10) || 0;
      const end = parseInt(bg.dataset.bgEnd, 10) || 0;
      const segment = end > start;
      const params = {
        autoplay: 1,
        mute: 1,
        controls: 0,
        playsinline: 1,
        rel: 0,
        disablekb: 1,
        iv_load_policy: 3,
        start,
        enablejsapi: 1,
        origin: window.location.origin,
      };
      // A whole clip loops through YouTube's own playlist trick; a stretch loops from here.
      if (segment) {
        params.end = end;
      } else {
        params.loop = 1;
        params.playlist = id;
      }
      const frame = document.createElement('iframe');
      frame.src = embed(id, params);
      frame.title = '';
      frame.tabIndex = -1;
      frame.setAttribute('aria-hidden', 'true');
      frame.allow = 'autoplay; encrypted-media';
      bg.appendChild(frame);
      root.dbaBackground = frame;

      // Ask the player for state updates and drop the thumbnail only once it really plays,
      // so a phone that blocks autoplay keeps the still image instead of a paused player.
      // The player ignores the request until its script is ready, so repeat it until it answers.
      let answered = false;
      let tries = 0;
      const ping = () => {
        if (answered || tries++ > 40 || !frame.contentWindow) return;
        frame.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: 1, channel: 'widget' }), '*');
        setTimeout(ping, 250);
      };
      frame.addEventListener('load', ping);
      window.addEventListener('message', (event) => {
        if (event.source !== frame.contentWindow || typeof event.data !== 'string') return;
        answered = true;
        let data;
        try {
          data = JSON.parse(event.data);
        } catch (error) {
          return;
        }
        const info = (data && data.info) || {};
        const state = info.playerState;
        if (state === 1 && !bg.classList.contains('is-playing')) {
          setTimeout(() => bg.classList.add('is-playing'), 1200);
        }
        if (segment && (state === 0 || (typeof info.currentTime === 'number' && info.currentTime >= end))) {
          tell(frame, 'seekTo', [start, true]);
          tell(frame, 'playVideo');
        }
      });
    };

    const playCard = (root, button) => {
      const id = button.dataset.videoId;
      const holder = document.createElement('div');
      holder.className = 'dba-videos__frame';
      const frame = document.createElement('iframe');
      frame.src = embed(id, { autoplay: 1, rel: 0, playsinline: 1 });
      frame.title = button.dataset.title || 'YouTube video';
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.allowFullscreen = true;
      holder.appendChild(frame);
      button.replaceWith(holder);
      frame.focus();
      tell(root.dbaBackground, 'pauseVideo');
      root.dbaCardPlaying = true;
    };

    const setup = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';

      root.addEventListener('click', (event) => {
        const play = event.target.closest('[data-video-id]');
        if (play) {
          playCard(root, play);
          return;
        }
        const arrow = event.target.closest('.dba-videos__arrow');
        if (arrow) {
          const list = root.querySelector('.dba-videos__list');
          const item = list.querySelector('.dba-videos__item');
          const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(list).columnGap || 0) : 300;
          list.scrollBy({ left: Number(arrow.dataset.dir) * step, behavior: 'smooth' });
        }
      });

      const list = root.querySelector('.dba-videos--row .dba-videos__list');
      if (list) {
        const arrows = root.querySelectorAll('.dba-videos__arrow');
        const sync = () => {
          const max = list.scrollWidth - list.clientWidth - 2;
          arrows.forEach((a) => {
            a.disabled = a.dataset.dir === '-1' ? list.scrollLeft <= 2 : list.scrollLeft >= max;
          });
        };
        list.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync);
        sync();
      }

      if (!root.querySelector('[data-bg-id]')) return;
      if (!('IntersectionObserver' in window)) {
        startBackground(root);
        return;
      }
      let inView = false;
      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            inView = entry.isIntersecting;
            if (inView) {
              startBackground(root);
              if (!root.dbaCardPlaying) tell(root.dbaBackground, 'playVideo');
            } else {
              tell(root.dbaBackground, 'pauseVideo');
            }
          });
        },
        { rootMargin: '300px 0px' }
      ).observe(root);
      // Browsers pause media in a hidden tab; pick the loop up again when the tab comes back.
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible' && inView && !root.dbaCardPlaying) {
          tell(root.dbaBackground, 'playVideo');
        }
      });
    };

    const init = () => document.querySelectorAll('[data-dba-videos]').forEach(setup);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
